import { ModuleWithProviders, NgModule } from '@angular/core';
import { ANALYTICS_PROVIDERS, GA_MEASUREMENT_ID } from './analytics.providers';
import { AnalyticsService } from './analytics.service';

@NgModule({
  providers: [
    ANALYTICS_PROVIDERS
  ]
})
export class AnalyticsModule {
    public static forRoot(gaMeasurementId: string): ModuleWithProviders<any> {
        return {
            ngModule: AnalyticsModule,
            providers: [AnalyticsService, { provide: GA_MEASUREMENT_ID, useValue: gaMeasurementId }]
        }
    }
}
